<template>
  <v-stepper v-model="stepper">
    <v-stepper-header>
      <v-stepper-step :complete="stepper > 1" editable step="1">Date & Time</v-stepper-step>
      <v-stepper-step :complete="stepper > 2" step="2">Tutor & AN</v-stepper-step>
      <v-stepper-step step="3">Finish</v-stepper-step>
    </v-stepper-header>
    <v-stepper-items>
      <v-stepper-content step="1">
        <v-toolbar dense flat color="white" class="box-shadow">
          <v-btn color="primary" class="box-shadow" @click="setToday">Today</v-btn>
          <v-spacer/>
          <v-btn text @click="$refs.gsEditEventCalendar.prev()">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-toolbar-title class="mx-3">
            {{ $moment(this.focus).format('MMMM YYYY') }}
          </v-toolbar-title>
          <v-btn text @click="$refs.gsEditEventCalendar.next()">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
          <v-spacer/>
          <v-toolbar-items style="height: auto">
            <v-select
                v-model="type"
                :items="type_options"
                item-text="label"
                item-value="value"
                menu-props="auto"
                hide-details
                single-line
                outlined
                dense
            ></v-select>
          </v-toolbar-items>
        </v-toolbar>

        <v-calendar ref="gsEditEventCalendar"
                    :now="today"
                    type="month"
                    v-model="focus"
                    color="primary"
                    :events="events"
                    :event-color="getEventColor"
                    :interval-minutes="90"
                    :interval-count="16"
                    :interval-height="40"
                    :event-more="false"
                    @click:event="selectSlot"
                    @change="loadAvailableDates"
        ></v-calendar>
      </v-stepper-content>
      <v-stepper-content step="2">
        <v-card-text v-if="session_item">
          <v-select label="Tutor"
                    v-model="session_item.tutor_id"
                    :items="available_tutors"
                    color="success"
                    item-text="nickname"
                    item-value="id"
                    item-color="success"
          >
            <template v-slot:item="{item}">
              <v-list-item-action>{{ item.nickname }}</v-list-item-action>
              <v-list-item-content>
                <div class="" v-html="item.summary"></div>
              </v-list-item-content>
            </template>
          </v-select>

          <v-select label="Change mock to"
                    color="success"
                    v-model="session_item.mock_id"
                    :items="staff_available_mocks"
                    item-color="success"
                    item-text="name"
                    item-value="id"
          >
            <template v-slot:item="{ item }">
              {{ item.practice_area.name }}/{{ item.session_type.name }}/{{ item.name }}
            </template>

            <template v-slot:selection="{ item }">
              {{ item.practice_area.name }}/{{ item.session_type.name }}/{{ item.name }}
            </template>
          </v-select>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-space-between">
          <v-btn @click="stepper--">Back</v-btn>
          <v-btn color="primary" @click="updateSession">Next</v-btn>
        </v-card-actions>
      </v-stepper-content>
      <v-stepper-content step="3">

      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
export default {
  props: {
    session: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    stepper: 1,
    session_item: null,
    available_dates_load_options: null,
    available_mocks: [],
    today: '',
    focus: '',
    type: 'month',
    type_options: [
      { value: 'month', label: 'Month'},
      { value: 'week', label: 'Week'},
      { value: 'day', label: 'Day'},
    ],
    available_dates: [],

    available_tutors: [],
    tutor_id: [],
    staff_available_mocks: [],
    mock: [],
    include_children: false,
    api_errors: []
  }),
  computed: {
    events: function () {
      let events = []

      if(this.session_item) {
        events.push({
          ...this.session_item,
          name: this.session_item.short_name,
          color: 'primary'
        })
      }

      if(this.session_item && this.available_dates && this.available_dates.length > 0) {
        let mapped_items = this.available_dates
            .filter(item => {
              let sameStart = this.$moment(this.session_item.start).isSame(item.start)
              let sameEnd = this.$moment(this.session_item.end).isSame(item.end)
              if(sameStart && sameEnd) return ;
              return item;
            })
            .map(item => ({...item, name: 'Available', type: 'slot'}))
        events.push(...mapped_items)
      }
      return events
    }
  },
  watch: {
    'session': function (val, oldVal) {
      if(oldVal=== null && val) this.boot()
    },

    'session_item.start': function (val, oldVal) {
      console.log(val, oldVal)

      //   if(oldVal !== undefined) {
      //     this.staff_available_mocks = []
      //     this.session.mock = null
      //     this.session.tutor = null
      //     this.loadAvailableTutors()
      //   }
      //
    },
    'session_item.tutor_id': function (val, oldVal) {
      console.log(val, oldVal)
      if(val && oldVal !== undefined) this.loadAvailableTutorMocks()
    }
  },
  created() {
    this.today = this.$currentTime().format('YYYY-MM-DD')
    this.focus = this.$currentTime().format('YYYY-MM-DD')
  },
  mounted() {
    console.log(this.session)
    if(this.session) this.boot()
  },
  methods: {
    boot() {
      this.session_item = Object.assign({}, this.session)
      this.today = this.$currentTime().format('YYYY-MM-DD')
      this.focus = this.$moment(this.session_item.start).format('YYYY-MM-DD')
      this.loadAvailableMocks()
    },
    setToday() {
      this.today = this.$currentTime().format('YYYY-MM-DD')
      this.focus = this.$currentTime().format('YYYY-MM-DD')
    },
    viewMore({date}) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor(event) {
      // return diff > 0 ? 'primary' : 'secondary'
      return event.color ? event.color : 'success'
    },
    selectSlot({event}) {
      this.session_item.start = event.start
      this.session_item.end = event.end
      this.stepper++
      this.loadAvailableTutors()
    },
    loadAvailableMocks() {
      if(!this.session_item) return ;
      this.axios.get(`api/sessions/${this.$route.params.session_id}/available-mocks`)
          .then(({data}) => {
            this.available_mocks = data.data
            this.loadAvailableDates(this.available_dates_load_options)
          })
          .catch(errors => { this.api_errors = errors.response.data.errors })
    },
    loadAvailableDates({start, end}) {
      this.available_dates_load_options = {start, end}
      if(!this.session_item || this.available_mocks.length === 0) return ;
      this.axios.get(`api/sessions/${this.$route.params.session_id}/available-slots`, {params: {
          mocks: this.available_mocks.map(item => item.id),
          date_from: start.date,
          date_to: end.date,
        }})
          .then(({data}) => { this.available_dates = data.data })
          .catch(errors => { this.api_errors = errors.response.data.errors })
    },
    loadAvailableTutors() {
      this.available_tutors = []
      this.staff_available_mocks = []
      this.axios.get(`api/sessions/${this.$route.params.session_id}/available-tutors`, {params: {
          mocks:  this.available_mocks.map(item => item.id),
          start: this.session_item.start,
          end: this.session_item.end,
        }})
          .then(({data}) => { this.available_tutors = data.data })
          .catch(errors => {
            this.api_errors = errors.response.data.errors
            this.available_tutors = []
          })
    },
    loadAvailableTutorMocks() {
      this.axios.get(`api/sessions/${this.$route.params.session_id}/available-tutor-mocks`, { params: {
          tutor_id: this.session_item ? this.session_item.tutor_id : null,
          mocks: this.available_mocks.map(item => item.id),
        }})
          .then(response => {this.staff_available_mocks = response.data.data})
          .catch(errors => {this.api_errors = errors.response.data.errors})
    },
    updateSession() {
      this.app_loading = true
      this.api_errors = []
      this.axios.put(`api/sessions/${this.$route.params.session_id}`,{
        mock_id: this.session_item.mock_id,
        tutor_id: this.session_item.tutor_id,
        start: this.session_item.start,
        end: this.session_item.end,
      })
          // eslint-disable-next-line no-unused-vars
          .then(({data}) => {
            // console.log(data)
            this.$emit('loadSession')
            this.$router.push({name:'Session info', params: this.$route.params})
          })
          .catch(errors => {this.api_errors = errors.response.data.errors })
          .then(() => {this.app_loading = false})
    }

  }
}
</script>